import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  startLearning: {
    id: `navigation_cta`,
  },
});
